import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function CompanyInteractiveList() {
  const { companies, selectCompany } = useAuth();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [selectedId, setSelectedId] = useState(
    () => JSON.parse(localStorage.getItem("selectedCompany") || "null")?.id || null
  );

  const filteredCompanies = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) {
      return companies;
    }
    return companies.filter((company) =>
      (company?.name || "").toLowerCase().includes(normalized)
    );
  }, [companies, query]);

  const selectedCompany = filteredCompanies.find((item) => item.id === selectedId);

  const handleSelect = (company) => {
    setSelectedId(company.id);
    selectCompany(company);
    navigate(`/suporte/empresa/${company.id}`);
  };

  if (!companies.length) {
    return (
      <section className="card">
        <h2>Empresas vinculadas</h2>
        <p>Seu usuário não possui empresas vinculadas no momento.</p>
      </section>
    );
  }

  return (
    <section className="companies-grid">
      <div className="card">
        <h2 className="page-title" style={{ fontSize: "1.1rem", marginBottom: 4 }}>
          Empresas vinculadas
        </h2>
        <p className="section-description" style={{ marginBottom: 12 }}>
          Selecione uma empresa para abrir o contexto de suporte.
        </p>
        <input
          className="search-input"
          placeholder="Buscar empresa por nome..."
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
        <div className="company-list">
          {filteredCompanies.map((company) => (
            <button
              key={company.id}
              className={`company-item ${selectedId === company.id ? "selected" : ""}`}
              onClick={() => handleSelect(company)}
              type="button"
            >
              <strong>{company.name}</strong>
              <span>ID: {company.id}</span>
            </button>
          ))}
        </div>
      </div>

      <aside className="card">
        <h2>Detalhes da empresa</h2>
        {selectedCompany ? (
          <div className="company-details">
            <p>
              <strong>Nome:</strong> {selectedCompany.name}
            </p>
            <p>
              <strong>ID:</strong> {selectedCompany.id}
            </p>
            <p>
              <strong>Status:</strong> {selectedCompany.status || "Ativa"}
            </p>
            <p>
              <strong>Ação:</strong> Empresa selecionada para contexto de suporte.
            </p>
          </div>
        ) : (
          <p>Selecione uma empresa para visualizar os detalhes.</p>
        )}
      </aside>
    </section>
  );
}
